import { QueryClient as rqQueryClient } from '@tanstack/react-query'

export type QueryClient = rqQueryClient
export const QueryClient = rqQueryClient
